var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToyota({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2597_2518",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2597_2518)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2597_2518",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 23
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2597_2518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9739 18.5915C10.9705 17.4367 11.8428 16.505 12.9323 16.503C13.9951 16.5048 14.8681 17.4365 14.8895 18.5915C14.8683 19.7335 13.9954 20.6652 12.9323 20.6813C11.8428 20.6652 10.9706 19.7335 10.9739 18.5915ZM12.9324 19.9115C13.5205 19.9018 14.0075 19.312 14.0135 18.5915C14.0075 17.8572 13.5205 17.2675 12.9324 17.2716C12.3188 17.2673 11.8307 17.857 11.8501 18.5915C11.8307 19.312 12.3188 19.9017 12.9324 19.9115ZM17.1048 17.3817V20.5713H16.281V17.3817H15.0956V16.668H18.2386V17.3817H17.1048ZM19.2169 19.6905L18.9084 20.5714H17.9302L19.4755 16.668H20.5054L22 20.5714H21.0217L20.7126 19.6905H19.2169ZM19.9909 19.0315H20.5054L19.9909 17.6015L19.4755 19.0315H19.9909ZM1.95758 17.3817V20.5713H1.13328V17.3817H0V16.668H3.0914V17.3817H1.95758ZM3.29754 18.5915C3.29917 17.4367 4.17097 16.505 5.25442 16.503C6.3239 16.5048 7.19702 17.4365 7.21278 18.5915C7.19702 19.7335 6.3239 20.6652 5.25442 20.6813C4.17097 20.6652 3.29909 19.7335 3.29754 18.5915ZM5.25442 19.9115C5.84954 19.9018 6.33608 19.312 6.33663 18.5915C6.33601 17.8572 5.84954 17.2675 5.25442 17.2716C4.64688 17.2673 4.15948 17.857 4.17369 18.5915C4.15948 19.312 4.64688 19.9017 5.25442 19.9115ZM9.0676 20.5713H9.47933V19.0864L10.9223 16.668H9.99529L9.0676 18.3166L8.19145 16.668H7.21285L8.65588 19.0864V20.5713H9.0676Z",
    fill: "#AB002F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.663086 8.07587C0.663086 11.8003 5.20147 14.8305 10.7797 14.8305C16.3578 14.8305 20.8963 11.8003 20.8963 8.07587C20.8962 4.35112 16.3578 1.32129 10.7796 1.32129C5.20139 1.32129 0.663086 4.35112 0.663086 8.07587ZM0.97353 8.07587C0.97353 4.53448 5.37244 1.65313 10.7797 1.65313C16.1868 1.65313 20.5858 4.53448 20.5858 8.07587C20.5858 11.618 16.1868 14.4993 10.7797 14.4993C5.37244 14.4992 0.97353 11.6181 0.97353 8.07587Z",
    fill: "#13141A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82373 2.5492C7.45597 2.70348 5.73619 3.37314 5.44306 4.25538C5.4132 4.34428 5.39782 4.43797 5.39758 4.5324C5.39758 4.68122 5.437 4.83004 5.51523 4.97232C5.84384 5.56976 6.86388 6.06243 8.31544 6.3267L8.46911 6.35353L8.49487 6.18972C8.73314 4.63882 9.25616 3.41926 9.93037 2.84344L10.3124 2.51682L9.82373 2.5492ZM5.78322 4.80528C5.73262 4.71344 5.70771 4.62283 5.70771 4.53356C5.70771 4.47724 5.71679 4.42225 5.73557 4.36627C5.95932 3.69231 7.47933 3.10365 9.42108 2.91375C8.86717 3.58233 8.44125 4.65969 8.21905 5.9686C6.95725 5.71949 6.04997 5.2905 5.78322 4.80528ZM9.39082 6.28885L9.36047 6.46906L9.53176 6.48297C9.93797 6.51535 10.3579 6.53283 10.7793 6.53283C11.201 6.53283 11.6212 6.51535 12.0275 6.48297L12.1985 6.46906L12.168 6.28885C11.9345 4.88942 11.415 4.05347 10.7795 4.05347C10.1436 4.05347 9.62427 4.88942 9.39082 6.28885ZM10.7796 4.38474C11.2141 4.38474 11.6151 5.07899 11.8265 6.16272C11.4829 6.18666 11.1329 6.20156 10.7793 6.20156C10.4261 6.20156 10.076 6.18666 9.73277 6.16272C9.94348 5.07899 10.3452 4.38474 10.7796 4.38474ZM11.6285 2.84361C12.3025 3.41943 12.826 4.63915 13.0643 6.18989L13.0898 6.3537L13.2432 6.32686C14.6954 6.0626 15.716 5.56976 16.0434 4.9724C16.1708 4.74284 16.195 4.49488 16.1162 4.25563C15.8231 3.37347 14.1033 2.70381 11.7357 2.54936L11.2477 2.51698L11.6285 2.84361ZM12.1387 2.91375C14.0799 3.10365 15.5999 3.69339 15.823 4.36627C15.8424 4.42225 15.8515 4.47724 15.8515 4.53356C15.8515 4.62283 15.826 4.71344 15.7766 4.80528C15.5089 5.29042 14.6013 5.71949 13.3401 5.9686C13.1179 4.65977 12.6926 3.58241 12.1387 2.91375ZM3.94485 4.90557C2.88073 5.85672 2.31836 6.98666 2.31836 8.17383C2.31836 10.9666 5.50972 13.3272 9.74131 13.6636L10.214 13.7014L9.85408 13.3734C8.92701 12.5271 8.35129 10.5191 8.35129 8.13276L8.361 7.56894L8.23123 7.54079C6.00542 7.11511 4.42193 6.11643 4.19647 4.99808L4.14253 4.72958L3.94485 4.90557ZM2.62911 8.17383C2.62911 7.15586 3.09447 6.17887 3.96821 5.33033C4.37528 6.46036 5.8963 7.40174 8.04628 7.83975C8.04357 7.96911 8.04116 8.13276 8.04116 8.13276C8.04116 10.3454 8.53321 12.2563 9.34479 13.2873C5.48908 12.8483 2.62911 10.6993 2.62911 8.17383ZM9.26439 7.87536L9.26346 7.93549C9.26346 10.1536 9.91523 11.8271 10.7796 11.8271C11.6436 11.8271 12.2955 10.1536 12.2955 7.93549L12.2934 7.69615L12.1267 7.71139C11.6871 7.75246 11.2345 7.77284 10.7797 7.77284C10.325 7.77284 9.87177 7.75246 9.43335 7.71139L9.26602 7.69524L9.26439 7.87536ZM11.9832 8.05317C11.9598 10.117 11.3505 11.4961 10.7796 11.4961C10.2081 11.4961 9.59874 10.117 9.576 8.05317C9.97073 8.08423 10.3739 8.10361 10.7796 8.10361C11.1859 8.10361 11.5879 8.08423 11.9832 8.05317ZM17.3622 4.99808C17.1369 6.11643 15.5531 7.11503 13.328 7.54079L13.1976 7.56662L13.208 8.13267C13.208 10.519 12.6319 12.5271 11.7052 13.3733L11.3453 13.7013L11.8173 13.6635C16.0493 13.3271 19.2407 10.9665 19.2407 8.17375C19.2407 6.98658 18.6777 5.85663 17.6136 4.90549L17.4166 4.7295L17.3622 4.99808ZM17.5904 5.33033C18.4648 6.17887 18.9304 7.15586 18.9304 8.17383C18.9304 10.6993 16.0706 12.8483 12.2145 13.2873C13.0261 12.2563 13.5182 10.3454 13.5182 8.13276C13.5182 8.13276 13.5151 7.96903 13.513 7.83975C15.6623 7.40174 17.1833 6.46028 17.5904 5.33033Z",
    fill: "#13141A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4722 4.14551C17.4865 4.18758 17.4996 4.23048 17.5098 4.27362C17.5683 4.52174 17.5562 4.76539 17.4804 5.00282C18.4899 5.89119 19.0851 6.98685 19.0851 8.17402C19.0851 11.1372 15.3664 13.5399 10.7796 13.5399C6.19249 13.5399 2.47414 11.1372 2.47414 8.17402C2.47414 6.98785 3.06989 5.89127 4.07821 5.00282C4.003 4.76539 3.9909 4.52174 4.04941 4.27362C4.06152 4.22654 4.07766 4.18075 4.09761 4.13681C2.72002 5.18411 1.88477 6.55662 1.88477 8.05982C1.88477 11.342 5.86683 14.0025 10.7795 14.0025C15.6916 14.0025 19.6743 11.342 19.6743 8.05982C19.6744 6.55977 18.8425 5.1904 17.4722 4.14551Z",
    fill: "url(#paint0_linear_2597_2518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.015 6.31811C11.623 6.34949 11.2098 6.36664 10.7789 6.36664C10.3484 6.36664 9.93554 6.34949 9.54353 6.31811H9.54229L9.2861 6.5167C9.75875 6.56068 10.2579 6.5856 10.7792 6.5856C11.3006 6.5856 11.7996 6.56068 12.2726 6.5167L12.015 6.31811ZM16.5584 4.23602C16.2462 3.13481 13.6723 2.32611 10.7793 2.32611C7.88669 2.32611 5.31288 3.13498 5.00065 4.23602C4.72963 5.19131 6.20905 6.07545 8.54313 6.4261L8.34033 6.16266C6.45221 5.8198 5.32995 5.0887 5.58886 4.31138C5.90264 3.36761 8.18177 2.68421 10.779 2.68421C13.3762 2.68421 15.6559 3.36777 15.9693 4.31138C16.2279 5.08878 15.1062 5.81988 13.2176 6.16266L13.0155 6.4261C15.3488 6.07545 16.8292 5.19131 16.5584 4.23602Z",
    fill: "url(#paint1_linear_2597_2518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54763 6.31798C9.7644 5.03267 10.2346 4.22944 10.78 4.22944C11.326 4.22944 11.7959 5.03267 12.0129 6.31798H12.0173L12.2708 6.51434C12.0568 4.81694 11.4705 3.73221 10.7804 3.73221C10.0898 3.73221 9.50378 4.81694 9.29004 6.51434L9.54352 6.31798H9.54763Z",
    fill: "url(#paint2_linear_2597_2518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3471 7.47617L12.1398 7.87633C12.1398 7.90549 12.141 7.93547 12.141 7.96586C12.141 10.0964 11.5304 11.7118 10.7796 11.7118C10.028 11.7118 9.41865 10.0962 9.41865 7.96586C9.41865 7.93224 9.41927 7.89886 9.41989 7.86664L9.21221 7.47617C9.2061 7.63857 9.20307 7.80109 9.20313 7.96362C9.20313 10.3791 9.90892 12.2089 10.7799 12.2089C11.6508 12.2089 12.3572 10.3791 12.3572 7.96362C12.3569 7.80108 12.3536 7.63856 12.3471 7.47617Z",
    fill: "url(#paint3_linear_2597_2518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54686 6.42708C8.84519 4.0678 9.73198 2.32593 10.7797 2.32593C9.65646 2.32593 8.69905 3.86913 8.34375 6.16728L8.54383 6.42708H8.54686Z",
    fill: "url(#paint4_linear_2597_2518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0125 6.42708H13.0146L13.2147 6.16728C12.86 3.86913 11.9019 2.32593 10.7793 2.32593C11.827 2.32609 12.7144 4.0678 13.0125 6.42708Z",
    fill: "url(#paint5_linear_2597_2518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.354 7.70262L13.0994 7.37814H13.0973C13.1116 7.63595 13.1197 7.89798 13.1197 8.16415C13.1197 11.3885 12.0717 14.0023 10.7793 14.0023C12.2284 14.0023 13.3623 11.5781 13.3623 8.16415C13.3623 8.00796 13.3592 7.85475 13.354 7.70262Z",
    fill: "url(#paint6_linear_2597_2518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4396 8.16421C8.4396 7.89804 8.44775 7.63601 8.46172 7.3782H8.46001L8.20475 7.70168C8.19934 7.85579 8.19652 8.01 8.19629 8.16421C8.19629 11.5782 9.33104 14.0024 10.7796 14.0024C9.48766 14.0024 8.4396 11.3885 8.4396 8.16421Z",
    fill: "url(#paint7_linear_2597_2518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4809 5.0027C17.8669 5.34241 18.1925 5.7131 18.4471 6.10681C18.359 5.48065 18.1255 4.88794 17.768 4.38257C17.6716 4.30077 17.5731 4.22174 17.4726 4.14555C17.487 4.18762 17.5 4.23052 17.5101 4.27367C17.5689 4.5217 17.5568 4.76526 17.4809 5.0027ZM4.07884 5.0027C4.00363 4.76526 3.99153 4.52162 4.05005 4.2735C4.06216 4.22642 4.07829 4.18062 4.09824 4.13669C3.99472 4.2164 3.89274 4.29838 3.79238 4.38257C3.43541 4.88826 3.20202 5.48083 3.11328 6.10681C3.36792 5.7131 3.69288 5.34233 4.07884 5.0027Z",
    fill: "#2D2F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.818359 8.07592C0.818359 4.43746 5.27789 1.48721 10.7797 1.48721C16.2808 1.48721 20.7404 4.43746 20.7404 8.07592C20.7404 11.7151 16.2808 14.6643 10.7797 14.6643C5.27789 14.6642 0.818359 11.7152 0.818359 8.07592ZM10.7797 14.0023C15.6918 14.0023 19.6744 11.3419 19.6744 8.05968C19.6744 4.77717 15.6918 2.11579 10.7797 2.11579C5.86688 2.11579 1.88458 4.77734 1.88458 8.05968C1.88458 11.3419 5.86695 14.0023 10.7797 14.0023Z",
    fill: "url(#paint8_linear_2597_2518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43945 8.16425C8.43945 4.97375 9.48751 2.32611 10.7793 2.32611C12.0716 2.32611 13.1198 4.97375 13.1198 8.16425C13.1198 11.3886 12.0716 14.0024 10.7793 14.0024C9.48689 14.0024 8.43945 11.3885 8.43945 8.16425ZM10.7793 12.2089C11.6503 12.2089 12.3567 10.3792 12.3567 7.96466C12.3567 5.45889 11.6502 3.73242 10.7793 3.73242C9.90832 3.73242 9.20252 5.45889 9.20252 7.96466C9.20252 10.3792 9.90832 12.2089 10.7793 12.2089Z",
    fill: "url(#paint9_linear_2597_2518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0489 4.27346C4.30563 3.18881 7.41054 1.61017 10.779 1.61017C14.1472 1.61017 17.1454 2.73813 17.5092 4.27346C17.9164 5.99438 14.9241 7.55183 10.779 7.55183C6.63327 7.55183 3.64113 5.99447 4.0489 4.27346ZM10.779 2.32603C7.88645 2.32603 5.31264 3.1349 5.00041 4.23594C4.65054 5.46949 7.21954 6.58553 10.779 6.58553C14.3392 6.58553 16.9077 5.46933 16.5582 4.23594C16.2459 3.13473 13.6722 2.32603 10.779 2.32603Z",
    fill: "url(#paint10_linear_2597_2518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20886 7.47295L9.21064 7.47427L9.42438 7.87635C9.85939 7.91602 10.3118 7.93871 10.7795 7.93871C11.2495 7.93871 11.703 7.9161 12.1408 7.87535L12.3488 7.47411L12.3501 7.47278C11.8499 7.52355 11.3254 7.55171 10.7797 7.55171C10.2552 7.55203 9.73101 7.52575 9.20886 7.47295ZM17.5449 4.6456C17.4915 5.87608 15.7189 6.96628 13.0988 7.37713L13.0997 7.37812L13.3553 7.70401C15.919 7.21224 17.6056 6.00428 17.5449 4.6456ZM4.01428 4.6456C3.95366 6.00561 5.64007 7.21216 8.20333 7.70401L8.45952 7.37812L8.46014 7.37713C5.83953 6.96636 4.06822 5.87617 4.01428 4.6456Z",
    fill: "url(#paint11_linear_2597_2518)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2597_2518",
    x1: 10.7795,
    y1: 13.2684,
    x2: 10.7795,
    y2: 5.76067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#E2E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#CCD0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CACED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#B3B7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#797C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52545C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2597_2518",
    x1: 10.7795,
    y1: 7.54793,
    x2: 10.7795,
    y2: 3.47966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#E2E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#CCD0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CACED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#B3B7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#797C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52545C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2597_2518",
    x1: 12.0461,
    y1: 6.80006,
    x2: 9.53942,
    y2: 4.82889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#E2E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#CCD0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CACED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#B3B7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#797C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52545C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2597_2518",
    x1: 12.2877,
    y1: 10.3461,
    x2: 8.70741,
    y2: 8.40894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#E2E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#CCD0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CACED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#B3B7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#797C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52545C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2597_2518",
    x1: 9.56178,
    y1: 1.48667,
    x2: 9.56178,
    y2: 7.93939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#E2E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#CCD0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CACED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#B3B7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#797C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52545C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2597_2518",
    x1: 11.997,
    y1: 1.48667,
    x2: 11.997,
    y2: 7.93939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#E2E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#CCD0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CACED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#B3B7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#797C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52545C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2597_2518",
    x1: 12.0707,
    y1: 1.43243,
    x2: 12.0707,
    y2: 12.2014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#E2E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#CCD0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CACED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#B3B7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#797C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52545C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2597_2518",
    x1: 9.48789,
    y1: 1.4324,
    x2: 9.48789,
    y2: 12.2013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#E2E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#CCD0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CACED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#B3B7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#797C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52545C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2597_2518",
    x1: 10.7793,
    y1: 1.48721,
    x2: 10.7793,
    y2: 14.6643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#EDF0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#E5E8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#D7DADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#C3C5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#888B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926,
    stopColor: "#63656B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2597_2518",
    x1: 10.7796,
    y1: 1.4866,
    x2: 10.7796,
    y2: 14.6645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#EDF0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#E5E8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#D7DADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#C3C5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#888B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926,
    stopColor: "#63656B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2597_2518",
    x1: 10.779,
    y1: 1.48793,
    x2: 10.779,
    y2: 14.6655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#EDF0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#E5E8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#D7DADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#C3C5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#888B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926,
    stopColor: "#63656B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2597_2518",
    x1: 10.7796,
    y1: 4.22017,
    x2: 10.7796,
    y2: 7.97573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52545C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToyota);
export default __webpack_public_path__ + "static/media/toyota.2b8120159600ffb892c391b0b10f0f1d.svg";
export { ForwardRef as ReactComponent };